import { getControlStyleIdByTitle } from '@/pages/Onboarding/options/ControlStyle/utils/getControlStyle';
import { getDominatrixVisualStyleIdByTitle } from '@/pages/Onboarding/options/DominatrixVisualStyle/utils/getDominatrixVisualStyle';
import { getSafewordChoiceIdByTitle } from '@/pages/Onboarding/options/SafewordChoice/utils/getSafewordChoice';
import { getToolsChoiceIdByTitle } from '@/pages/Onboarding/options/Tools/utils/getToolsChoice';
import { getVoiceStyleIdByTitle } from '@/pages/Onboarding/options/VoiceStyle/utils/getVoiceStyle';

import { layoutDataDefault } from '../constants';

import type { LayoutDataType } from '../types';

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataType,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    control_style: getControlStyleIdByTitle(onb_data.control_style),
    dominatrix_visual_style: getDominatrixVisualStyleIdByTitle(
      onb_data.dominatrix_visual_style,
    ),
    voice_style: getVoiceStyleIdByTitle(onb_data.voice_style),
    safeword_choice: getSafewordChoiceIdByTitle(onb_data.safeword_choice),
    safeword_input: onb_data.safeword_input,
    tools: getToolsChoiceIdByTitle(onb_data.tools),
    name: onb_data.name || layoutDataDefault.name,
  };
};
